import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login, refreshSession } from '../services/api';
import { isAuthenticated } from '../services/auth';
import { useTranslation } from 'react-i18next';

const LoginPage = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated()) {
      navigate('/admin', { replace: true });
      return;
    }

    refreshSession()
      .then(() => {
        navigate('/admin', { replace: true });
      })
      .catch(() => {
        // no-op; user stays on login page
      });
  }, [navigate]);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    try {
      await login(email, password);
      navigate('/admin');
    } catch (ex) {
      setError(t('login.invalidCredentials', 'Email or password is incorrect.'));
    }
  };

  return (
    <div className="page-grid" style={{ minHeight: '100vh', placeItems: 'center', display: 'grid', padding: '1.5rem' }}>
      <div className="admin-panel" style={{ width: '100%', maxWidth: 420, padding: '2rem' }}>
        <h1 style={{ marginTop: 0 }}>{t('login.title', 'Admin Login')}</h1>
        <form onSubmit={handleSubmit} className="form-grid" style={{ marginTop: '1.5rem' }}>
          <div className="form-group">
            <label htmlFor="login-email">{t('login.emailLabel', 'Email')}</label>
            <input
              id="login-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="form-control"
            />
          </div>
          <div className="form-group">
            <label htmlFor="login-password">{t('login.passwordLabel', 'Password')}</label>
            <input
              id="login-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="form-control"
            />
          </div>
          {error && <p className="alert alert-error" style={{ margin: 0 }}>{error}</p>}
          <button type="submit" className="btn btn-primary">
            {t('login.signIn', 'Sign in')}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
